import PropTypes from 'prop-types'
import React from 'react'

function DelayedDetailsRow({ delayed, delayedTotal, iconName, text }) {
  if (!delayed) {
    return null
  }

  return (
    <div className="completeness-details-delayed-count">
      <span className="completeness-details-delayed-count-stores">
        <i className={`fm fm-${iconName}`} /> {delayed}
      </span>
      <span className="completeness-details-delayed-count-all-stores">/{delayedTotal}</span>
      <span className="completeness-details-delayed-count-label">{text}</span>
    </div>
  )
}

DelayedDetailsRow.propTypes = {
  delayed: PropTypes.number,
  delayedTotal: PropTypes.number,
  iconName: PropTypes.string,
  text: PropTypes.string,
}

export default DelayedDetailsRow
